import React, { useState, useEffect, useRef } from "react";

import {
  Form,
  Input,
  Button,
  Spin,
  Alert,
  Layout,
  Row,
  Col,
  Card,
  Typography,
  Tooltip,
  notification,
} from "antd";

import { withRouter } from "react-router-dom";
import {
  MailOutlined,
  LoadingOutlined,
  LockOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { updatePassword } from "../../../redux/correo/moduloCorreoDucks";
import { updateEstatus } from "../../../redux/usuario/usuarioDucks";

//import { valueLowerCase } from "../../../utils";
import { linksRouter } from "../../../config/RouterLink";

const { Item } = Form;
const { Text, Paragraph } = Typography;

function UpdatePassword(props) {
  const { messageError, indicadorError, correo } = useSelector(
    (store) => store.usuarioLogin
  );

  const [error] = useState(false);
  const [messageAlert, setMessageAlert] = useState("");
  const [cargandoInfo, setCargandoInfo] = useState(false);
  const isMounted = useRef(true);

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const onFinish = (values) => {
    let datapass = {
      usuarioAspirante: correo,
      contrasenia: values.contrasenia,
      usuario: correo,
    };
    setCargandoInfo(true);
    dispatch(updatePassword(datapass)).then(() => {
      setMessageAlert("La contraseña se ha actualizado con Éxito");
      dispatch(updateEstatus("1"));
      // props.history.push(linksRouter.home);
      props.history.push({
        pathname: linksRouter.home,
        state: { update: true },
      });
      setCargandoInfo(false);
      NotificationCambioPassword("success");
    });
  };

  const NotificationCambioPassword = (type) => {
    notification[type]({
      message: "Actualización éxitosa",
      description:
        "Se ha realizado la actualización de tu contraseña con éxito.",
      duration: 6,
    });
  };

  return (
    <Layout className="body-style">
      <Row align="center" className="top-row-form">
        <Col span={2} xxl={5} xl={10} lg={10} md={12} sm={12} xs={12}>
          <Card className="card-form-actualiza">
            <Typography>
              <center>
                <Text className="txt-actualizar-pwd">
                  Actualizar contraseña
                </Text>
              </center>
              <Paragraph>
                <p className="txt-actualizar-parrafo">
                  Por favor verifica tu correo electrónico y registra una nueva
                  contraseña.
                </p>
              </Paragraph>
            </Typography>

            <div className="">
              <Spin
                spinning={cargandoInfo}
                size="large"
                indicator={<LoadingOutlined style={{ fontSize: 50 }} spin />}
              >
                <div className="login-container">
                  <Form name="basic" className="login-form" onFinish={onFinish}>
                    <div>
                      {indicadorError && (
                        <Alert
                          message={messageError}
                          type="error"
                          showIcon
                          closable
                        />
                      )}
                    </div>
                    <center>
                      <Item
                        name="usuario"
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: "Por favor escribe tu correo electrónico",
                        //   },
                        //   {
                        //     type: "email",
                        //     message: "Formato inválido",
                        //   },
                        //   { validateStatus: "error" },
                        // ]}
                        // getValueFromEvent={valueLowerCase}
                      >
                        <Input
                          prefix={<MailOutlined style={{ color: "#d5007f" }} />}
                          defaultValue={correo}
                          disabled={true}
                          type="email"
                          style={{ width: "300px", marginTop: "36px" }}
                          size="large"
                          maxLength={100}
                        />
                      </Item>

                      <Row align="top">
                        <Col span={1}>
                          <Tooltip
                            placement="left"
                            title={
                              <ol>
                                Reglas para contraseña:
                                <br />
                                <li>Al menos una letra mayúscula.</li>
                                <li>Mayor a 7 caracteres.</li>
                                <li>Al menos un número.</li>
                                <li>
                                  Un carácter especial (!@#$%&¿?_+:;=[]()/¬|{}).
                                </li>
                              </ol>
                            }
                            color={"#D5007F"}
                          >
                            <QuestionCircleOutlined />
                          </Tooltip>
                        </Col>
                      </Row>
                      <Item
                        name="contrasenia"
                        rules={[
                          {
                            required: true,
                            message: "Por favor ingresa una contraseña",
                          },
                          () => ({
                            validator(_, value) {
                              if (value.length < 8) {
                                return Promise.reject(
                                  new Error(
                                    "La contraseña debe tener más de 8 caracteres"
                                  )
                                );
                              }
                              if (!value.match(/[A-z]/)) {
                                return Promise.reject(
                                  new Error(
                                    "La contraseña debe tener al menos una letra"
                                  )
                                );
                              }
                              if (!value.match(/[A-Z]/)) {
                                return Promise.reject(
                                  new Error(
                                    "La contraseña debe tener al menos una letra mayúscula"
                                  )
                                );
                              }
                              if (!value.match(/\W|_/g)) {
                                return Promise.reject(
                                  new Error(
                                    "La contraseña debe tener al menos un caracter especial"
                                  )
                                );
                              }
                              if (!value.match(/[0-9]/)) {
                                return Promise.reject(
                                  new Error(
                                    "La contraseña debe tener al menos un número"
                                  )
                                );
                              } else {
                                return Promise.resolve("");
                              }
                            },
                          }),
                        ]}
                      >
                        <Input.Password
                          prefix={<LockOutlined style={{ color: "#d5007f" }} />}
                          placeholder="Contraseña"
                          type="password"
                          style={{ width: "300px", marginTop: "2px" }}
                          maxLength={15}
                          minLength={8}
                          size="large"
                        />
                      </Item>

                      <div>
                        {error && (
                          <Alert
                            message={messageAlert}
                            type="error"
                            showIcon
                            closable
                          />
                        )}
                      </div>
                      <Item>
                        <div>
                          <Button
                            type="primary"
                            htmlType="submit"
                            className="btn-actualiza"
                            size="large"
                          >
                            Actualizar contraseña
                          </Button>
                        </div>
                      </Item>
                    </center>
                  </Form>
                </div>
              </Spin>
            </div>
          </Card>
        </Col>
      </Row>
    </Layout>
  );
}
export default withRouter(UpdatePassword);
